// Enum for keyboard keys
export enum KeyboardKey {
  Escape = 'Escape',
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  Enter = 'Enter',
}

// Generic dropdown keyboard handler
export interface DropdownKeyDownOptions<T> {
  disabled: boolean;
  items: T[];
  activeIndex: number;
  setActiveIndex: (fn: (prev: number) => number) => void;
  onSelect: (item: T) => void;
  closeDropdown: () => void;
  focusButton: () => void;
}

export function handleDropdownKeyDown<T>(
  e: React.KeyboardEvent,
  options: DropdownKeyDownOptions<T>,
) {
  const {
    disabled,
    items,
    activeIndex,
    setActiveIndex,
    onSelect,
    closeDropdown,
    focusButton,
  } = options;
  if (disabled) return;
  switch (e.key) {
    case KeyboardKey.Escape:
      closeDropdown();
      focusButton();
      break;
    case KeyboardKey.ArrowDown:
      e.preventDefault();
      setActiveIndex((prev) => (prev < items.length - 1 ? prev + 1 : 0));
      break;
    case KeyboardKey.ArrowUp:
      e.preventDefault();
      setActiveIndex((prev) => (prev > 0 ? prev - 1 : items.length - 1));
      break;
    case KeyboardKey.Enter:
      if (activeIndex >= 0) {
        onSelect(items[activeIndex]);
        closeDropdown();
        focusButton();
      }
      break;
    default:
      break;
  }
}
